module.exports = __webpack_public_path__ + "img/created.aae17b5c.svg";